"use client";
import { jsx as e } from "react/jsx-runtime";
import { cva as N } from "class-variance-authority";
import { forwardRef as g } from "react";
import { cn as s } from "./index.es21.js";
import { useIconLoader as x } from "./index.es22.js";
import { Skeleton as C } from "./index.es11.js";
const k = N("", {
  variants: {
    variant: {
      blue: "[&_path]:fill-blue-600",
      pink: "[&_path]:fill-pink-500",
      yellow: "[&_path]:fill-yellow-500"
    }
  },
  defaultVariants: {
    variant: "blue"
  }
}), u = (n) => "icon" in n && n.icon !== void 0, a = (n) => "name" in n && n.name !== void 0, w = g((n, l) => {
  const { className: f, width: t, height: i, ...m } = n, v = a(n) ? n.name : void 0, h = a(n) ? n.variant : void 0, { component: d, isLoading: I, hasError: y } = x(v, h);
  let r;
  u(n) ? r = n.variant ? k({ variant: n.variant }) : void 0 : a(n) && (r = void 0);
  const o = s(r, f);
  if (u(n)) {
    const c = n.icon;
    return /* @__PURE__ */ e(c, { ref: l, className: o, width: t, height: i, ...m });
  }
  if (a(n) && y)
    return /* @__PURE__ */ e(
      "div",
      {
        className: s(
          "flex items-center justify-center text-red-500 border border-red-200 rounded",
          o
        ),
        style: { width: t, height: i },
        role: "img",
        "aria-label": `Failed to load icon: ${n.name}`,
        title: `Icon "${n.name}" failed to load`,
        children: /* @__PURE__ */ e("span", { className: "text-xs select-none", "aria-hidden": "true", children: "⚠️" })
      }
    );
  if (a(n) && I)
    return /* @__PURE__ */ e(C, { width: t, height: i, variant: "circular", "data-testid": "skeleton" });
  if (a(n) && d) {
    const c = d;
    try {
      return (
        // eslint-disable-next-line react-hooks/error-boundaries
        /* @__PURE__ */ e(
          c,
          {
            ref: l,
            className: o,
            width: t,
            height: i,
            role: "img",
            "aria-label": n["aria-label"] || n.name,
            ...m
          }
        )
      );
    } catch (b) {
      return console.error("Error rendering DynamicIcon:", b), null;
    }
  }
  return null;
});
w.displayName = "Icon";
export {
  w as Icon,
  w as default
};
